import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import type { AdminRole } from "../types/auth";

const roleLabels: Record<AdminRole, string> = {
  global_admin: "Administrateur global",
  formation_admin: "Administrateur formation",
  trainer: "Formateur",
};

export function AccountMenu() {
  const { isAdmin, profile, signOutUser, user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const connectedLogin = profile?.email || user?.email || "Compte";

  return (
    <div className="user-menu">
      <button
        aria-expanded={isOpen}
        className="user-menu-trigger"
        onClick={() => setIsOpen((current) => !current)}
        type="button"
      >
        <span>{connectedLogin}</span>
        <small>{profile ? roleLabels[profile.role] : "Profil"}</small>
      </button>
      {isOpen ? (
        <div className="user-menu-popover" role="menu">
          {isAdmin ? (
            <a href="#/admin" onClick={() => setIsOpen(false)} role="menuitem">
              Administration
            </a>
          ) : null}
          <a href="#/profile/account" onClick={() => setIsOpen(false)} role="menuitem">
            Profil
          </a>
          <a href="#/profile/bio" onClick={() => setIsOpen(false)} role="menuitem">
            Bio
          </a>
          <a href="#/profile/access" onClick={() => setIsOpen(false)} role="menuitem">
            Accès
          </a>
          <button
            className="user-menu-danger"
            onClick={() => {
              setIsOpen(false);
              void signOutUser();
            }}
            role="menuitem"
            type="button"
          >
            Déconnexion
          </button>
        </div>
      ) : null}
    </div>
  );
}
